import { Button } from '../Input2';
import Popup, { PopupProps } from './Popup';

type DeleteContactHubspotPopupProps = PopupProps & {
  onClose: () => void;
  onDelete: () => void;
};

export default function DeleteContactHubspotPopup({ onClose, onDelete }: DeleteContactHubspotPopupProps) {
  return (
    <Popup onClose={onClose} className="max-w-lg">
      <h2 className="text-xl font-bold dark:text-gray-100">Are you sure?</h2>
      <p className="dark:text-gray-300">
        This will remove the HubSpot sync record for this contact. The contact will no longer appear on this page. This
        does not delete the contact in Poseidon or in HubSpot.
      </p>
      <Button color="red" onClick={onDelete}>
        Yes, delete HubSpot sync record
      </Button>
    </Popup>
  );
}
